import { inject } from './inject';
import { MarketingEmails as BaseMarketingEmails } from './MarketingEmails';

export const MarketingEmails = inject(BaseMarketingEmails);
